// extracted by mini-css-extract-plugin
export var ps = "hero-module--ps--Xksv3";
export var cta = "hero-module--cta--Kx8yC";
export var setNumber = "hero-module--setNumber--0P8O4";